import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, vShow as _vShow, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pop_up flex_box com_pop",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "pop_tit _flex" }
const _hoisted_3 = { class: "report_title_wrap" }
const _hoisted_4 = { class: "btns" }
const _hoisted_5 = { class: "close_btn icon_wrap" }
const _hoisted_6 = { class: "report_modal" }
const _hoisted_7 = { class: "_flex parts" }
const _hoisted_8 = { class: "left_part result_form" }
const _hoisted_9 = { class: "tag_wrap" }
const _hoisted_10 = { class: "tag_gray" }
const _hoisted_11 = {
  key: 0,
  class: "tag_red"
}
const _hoisted_12 = {
  key: 1,
  class: "tag_red"
}
const _hoisted_13 = { class: "li_con" }
const _hoisted_14 = { class: "li_con" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "file_wrap" }
const _hoisted_17 = { class: "custom_scroll" }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "right_part" }
const _hoisted_22 = { class: "result_form" }
const _hoisted_23 = { class: "radio_wrap" }
const _hoisted_24 = { class: "input_wrap _flex _column" }
const _hoisted_25 = { for: "chk1_yes" }
const _hoisted_26 = { for: "chk1_no" }
const _hoisted_27 = { class: "" }
const _hoisted_28 = { class: "select_tab_box_wrap w_100" }
const _hoisted_29 = { class: "select_tab_box" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "radio_wrap" }
const _hoisted_32 = { class: "input_wrap _flex _column w_100" }
const _hoisted_33 = { for: "chk2_yes" }
const _hoisted_34 = ["checked"]
const _hoisted_35 = { class: "select_tab_box_wrap w_100 select_list" }
const _hoisted_36 = { class: "select_tab_box" }
const _hoisted_37 = { class: "tab_option" }
const _hoisted_38 = ["onClick", "onChange"]
const _hoisted_39 = {
  key: 0,
  class: "select_tab_box_wrap w_100 select_list"
}
const _hoisted_40 = { class: "select_tab_box" }
const _hoisted_41 = { class: "tab_option" }
const _hoisted_42 = ["onClick", "onChange"]
const _hoisted_43 = { for: "chk2_no" }
const _hoisted_44 = ["checked"]
const _hoisted_45 = {
  key: 1,
  class: "select_tab_box_wrap w_100"
}
const _hoisted_46 = { class: "select_tab_box" }
const _hoisted_47 = { class: "tab_option" }
const _hoisted_48 = ["onClick", "onChange"]
const _hoisted_49 = { class: "" }
const _hoisted_50 = {
  class: "_flex _center btn_wrap",
  style: {"margin-top":"20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Comment = _resolveComponent("Comment")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer com_pop",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[18] || (_cache[18] = _createElementVNode("p", null, "시민제보 상태 수정", -1)),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.$props.prevInfo && _ctx.$props.prevInfo.idx)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "table_btn _blue",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.getPrevInfo(_ctx.$props.prevInfo.idx)))
                }, " 이전 "))
              : _createCommentVNode("", true),
            (_ctx.$props.nextInfo && _ctx.$props.nextInfo.idx)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "table_btn _blue",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.getNextInfo(_ctx.$props.nextInfo.idx)))
                }, " 다음 "))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("button", _hoisted_5, [
          _createElementVNode("img", {
            src: "img/close.png",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args))),
            alt: "닫기"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString($setup.state.data.state === 1 ? "대기중" : "접수완료"), 1),
                ($setup.state.data.type === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.state.data.isSchool === 0 ? "학교 주변 외" : "학교 주변"), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($setup.strAdType($setup.state.data.adType)), 1))
              ]),
              _createElementVNode("li", null, [
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "form_li_tit" }, "제보자 닉네임", -1)),
                _createElementVNode("span", null, _toDisplayString($setup.state.data.nickname != null ? $setup.state.data.nickname : "익명"), 1)
              ]),
              _createElementVNode("li", null, [
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "form_li_tit" }, "업소명", -1)),
                _createElementVNode("span", null, _toDisplayString($setup.state.data.shopName), 1)
              ]),
              _createElementVNode("li", null, [
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "form_li_tit" }, "업소주소", -1)),
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString($setup.state.data.address) + " ", 1),
                  _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" " + _toDisplayString($setup.state.data.addressDetail), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_13, [
                _cache[23] || (_cache[23] = _createElementVNode("span", { class: "form_li_tit" }, "업소 전화번호", -1)),
                _createElementVNode("span", null, _toDisplayString($setup.state.data.number), 1)
              ]),
              _createElementVNode("li", _hoisted_14, [
                _cache[24] || (_cache[24] = _createElementVNode("span", { class: "form_li_tit" }, "업소 URL", -1)),
                _createElementVNode("a", {
                  href: "#",
                  class: "underline",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($setup.openUrl($setup.state.data.adUrl)), ["prevent"]))
                }, _toDisplayString($setup.state.data.adUrl), 1)
              ]),
              _createElementVNode("li", _hoisted_15, [
                _cache[25] || (_cache[25] = _createElementVNode("label", {
                  for: "con",
                  class: "form_li_tit"
                }, "내용", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  name: "",
                  id: "con",
                  class: "custom_scroll h_270",
                  disabled: "",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.data.content) = $event))
                }, null, 512), [
                  [_vModelText, $setup.state.data.content]
                ])
              ]),
              _createElementVNode("li", _hoisted_16, [
                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "form_li_tit" }, "첨부", -1)),
                _createElementVNode("ul", _hoisted_17, [
                  ($setup.state.data.fileList != null && $setup.state.data.fileList.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.data.fileList, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          style: {"gap":"0 !important"},
                          key: item.idx
                        }, [
                          _createElementVNode("a", {
                            href: item.file,
                            class: "down underline",
                            target: "_blank"
                          }, _toDisplayString(item.imgRealName), 9, _hoisted_18),
                          _createElementVNode("button", {
                            class: "downIcon",
                            type: "button",
                            onClick: _withModifiers(($event: any) => ($setup.downloadFile(item.file, item.imgRealName)), ["prevent","stop"]),
                            style: {"margin-left":"5px"}
                          }, [...(_cache[26] || (_cache[26] = [
                            _createElementVNode("img", {
                              src: "img/download.png",
                              alt: "다운로드"
                            }, null, -1)
                          ]))], 8, _hoisted_19)
                        ]))
                      }), 128))
                    : (_openBlock(), _createElementBlock("li", _hoisted_20, "등록된 파일이 없습니다."))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("ul", _hoisted_22, [
              _createElementVNode("li", _hoisted_23, [
                _cache[32] || (_cache[32] = _createElementVNode("span", { class: "form_li_tit" }, "게시글 상태", -1)),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "chk1",
                      id: "chk1_yes",
                      value: "1",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.state.data.state) = $event))
                    }, null, 512), [
                      [_vModelRadio, $setup.state.data.state]
                    ]),
                    _cache[28] || (_cache[28] = _createElementVNode("em", null, null, -1)),
                    _cache[29] || (_cache[29] = _createElementVNode("span", null, "대기중", -1))
                  ]),
                  _createElementVNode("label", _hoisted_26, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "chk1",
                      id: "chk1_no",
                      value: "2",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.data.state) = $event))
                    }, null, 512), [
                      [_vModelRadio, $setup.state.data.state]
                    ]),
                    _cache[30] || (_cache[30] = _createElementVNode("em", null, null, -1)),
                    _cache[31] || (_cache[31] = _createElementVNode("span", null, "접수완료", -1))
                  ])
                ])
              ]),
              ($setup.state.data.state == 2)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("li", _hoisted_27, [
                      _cache[33] || (_cache[33] = _createElementVNode("span", { class: "form_li_tit" }, "업종분류", -1)),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["selected_tab", { active: $setup.state.isShowCategoryType }]),
                            onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.state.isShowCategoryType = !$setup.state.isShowCategoryType))
                          }, [
                            _createElementVNode("span", null, _toDisplayString($setup.state.detailTxt), 1)
                          ], 2),
                          _withDirectives(_createElementVNode("div", {
                            class: _normalizeClass(["tab_option", { active: $setup.state.isShowCategoryType }])
                          }, [
                            _createElementVNode("button", {
                              onClick: _cache[9] || (_cache[9] = ($event: any) => {
                                                    $setup.state.categoryType = 0;
                                                    $setup.state.detailTxt = '전체';
                                                    $setup.state.isShowCategoryType = false;
                                                })
                            }, " 전체 "),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.categoryList, (item) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: item.caIdx,
                                onClick: ($event: any) => {
                                                    $setup.state.categoryType = item.caIdx;
                                                    $setup.state.detailTxt = item.caName;
                                                    $setup.state.isShowCategoryType = false;
                                                }
                              }, _toDisplayString(item.caName), 9, _hoisted_30))
                            }), 128))
                          ], 2), [
                            [_vShow, $setup.state.isShowCategoryType]
                          ])
                        ])
                      ])
                    ]),
                    _cache[39] || (_cache[39] = _createElementVNode("hr", null, null, -1)),
                    _createElementVNode("li", _hoisted_31, [
                      _cache[38] || (_cache[38] = _createElementVNode("span", { class: "form_li_tit" }, "고발 / 신고", -1)),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("label", _hoisted_33, [
                          _createElementVNode("input", {
                            type: "radio",
                            name: "chk2",
                            id: "chk2_yes",
                            value: "1",
                            checked: $setup.state.data.isReport == 1,
                            onChange: _cache[10] || (_cache[10] = ($event: any) => ($setup.state.data.isReport = 1))
                          }, null, 40, _hoisted_34),
                          _cache[34] || (_cache[34] = _createElementVNode("em", null, null, -1)),
                          _cache[35] || (_cache[35] = _createElementVNode("span", null, "가능", -1))
                        ]),
                        ($setup.state.data.isReport == 1)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["selected_tab", { active: $setup.state.isShowreportState }]),
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.state.isShowreportState = !$setup.state.isShowreportState))
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString($setup.state.reportStateTxt), 1)
                                  ], 2),
                                  _withDirectives(_createElementVNode("div", _hoisted_37, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectOption.reportType, (value) => {
                                      return (_openBlock(), _createElementBlock("button", {
                                        type: "button",
                                        onClick: ($event: any) => {
                                                            $setup.state.data.reportState = value.id;
                                                            $setup.state.reportStateTxt = value.name;
                                                            $setup.state.isShowreportState = false;
                                                        },
                                        onChange: ($event: any) => ($setup.state.data.reportState = value.id)
                                      }, _toDisplayString(value.name), 41, _hoisted_38))
                                    }), 256))
                                  ], 512), [
                                    [_vShow, $setup.state.isShowreportState]
                                  ])
                                ])
                              ]),
                              ($setup.state.data.reportState == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["selected_tab", { active: $setup.state.isShowReportType }]),
                                        onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.state.isShowReportType = !$setup.state.isShowReportType))
                                      }, [
                                        _createElementVNode("span", null, _toDisplayString($setup.state.reportTypeTxt), 1)
                                      ], 2),
                                      _withDirectives(_createElementVNode("div", _hoisted_41, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectOption.report, (value) => {
                                          return (_openBlock(), _createElementBlock("button", {
                                            type: "button",
                                            onClick: ($event: any) => {
                                                                $setup.state.data.reportType = value.id;
                                                                $setup.state.reportTypeTxt = value.name;
                                                                $setup.state.isShowReportType = false;
                                                            },
                                            onChange: ($event: any) => ($setup.state.data.reportType = value.id)
                                          }, _toDisplayString(value.name), 41, _hoisted_42))
                                        }), 256))
                                      ], 512), [
                                        [_vShow, $setup.state.isShowReportType]
                                      ])
                                    ])
                                  ]))
                                : _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 1,
                                    type: "text",
                                    class: "select_type_text",
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.state.data.reportMemo) = $event)),
                                    placeholder: "내용을 입력하세요"
                                  }, null, 512)), [
                                    [_vModelText, $setup.state.data.reportMemo]
                                  ])
                            ], 64))
                          : _createCommentVNode("", true),
                        _createElementVNode("label", _hoisted_43, [
                          _createElementVNode("input", {
                            type: "radio",
                            name: "chk2",
                            id: "chk2_no",
                            value: "2",
                            checked: $setup.state.data.isReport == 2,
                            onChange: _cache[14] || (_cache[14] = ($event: any) => ($setup.state.data.isReport = 2))
                          }, null, 40, _hoisted_44),
                          _cache[36] || (_cache[36] = _createElementVNode("em", null, null, -1)),
                          _cache[37] || (_cache[37] = _createElementVNode("span", null, "불가능", -1))
                        ]),
                        ($setup.state.data.isReport == 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["selected_tab", { active: $setup.state.isShowReportReasonType }]),
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.state.isShowReportReasonType = !$setup.state.isShowReportReasonType))
                                }, [
                                  _createElementVNode("span", null, _toDisplayString($setup.state.reportReasonTxt), 1)
                                ], 2),
                                _withDirectives(_createElementVNode("div", _hoisted_47, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectOption.unReport, (value) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                      type: "button",
                                      onClick: ($event: any) => {
                                                            $setup.state.data.reason = value.id;
                                                            $setup.state.reportReasonTxt = value.name;
                                                            $setup.state.isShowReportReasonType = false;
                                                        },
                                      onChange: ($event: any) => ($setup.state.data.reason = value.id)
                                    }, _toDisplayString(value.name), 41, _hoisted_48))
                                  }), 256))
                                ], 512), [
                                  [_vShow, $setup.state.isShowReportReasonType]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _cache[41] || (_cache[41] = _createElementVNode("hr", null, null, -1)),
              _createElementVNode("li", _hoisted_49, [
                _cache[40] || (_cache[40] = _createElementVNode("label", {
                  for: "memo",
                  class: "form_li_tit"
                }, "메모", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  name: "",
                  id: "memo",
                  class: "custom_scroll h_127",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.state.data.memo) = $event)),
                  placeholder: "메모 내용을 입력해주세요"
                }, null, 512), [
                  [_vModelText, $setup.state.data.memo]
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_Comment, {
          idx: $setup.state.data.idx,
          type: $setup.state.data.type
        }, null, 8, ["idx", "type"])
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("button", {
          class: "submit_btn _130 _main_blue",
          onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.save($setup.state.data.type)))
        }, "저장")
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal2,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}